<template>
        <v-tooltip top transition="scroll-y-transition">
        <template v-slot:activator="{ on }">
            <v-btn v-on="on" :height="35" :width="35" depressed icon @click="navigateToMarker()" :disabled="!hasPermission('read:map') || disabled">
              <v-icon :size="15" color="secondary">fas fa-map-marker-alt</v-icon>
            </v-btn>
        </template>
        <span>{{ t({s: 'tooltips.mapLocation', component: 'ImeiStatus'}) }}</span>
        </v-tooltip>
</template>
<script lang="js">
export default {
  name: 'LocationMarker',
  props: {
    imei: null,
    disabled: false
  },
  methods: {
    navigateToMarker () {
      const imei = this.imei
      if (imei) {
        this.$router.push(`/map/${imei}`)
      }
    }
  }
}
</script>
